import { GalleryAppContent } from "../typings/gallery";

export const DEFAULT_MODE_CONTENT: GalleryAppContent = {};
